export default __webpack_public_path__ + "static/media/learose-1920w.6a73da4d.avif";